export interface User {
  id?: number;
  userId?: number;
  name?: string | null;
  username?: string | null;
  email?: string | null;
}

/**
 * 取得使用者的顯示名稱，優先順序：name → username → email → fallback
 */
export function getUserDisplayName(user: User | null | undefined, fallback = 'Unknown'): string {
  if (!user) return fallback;
  return user.name || user.username || user.email || fallback;
}

/**
 * 取得使用者的次要資訊，用於輔助顯示
 */
export function getUserSecondaryInfo(user: User | null | undefined): string | null {
  if (!user) return null;
  if (user.name) {
    return user.username || user.email || null;
  }
  if (user.username) {
    return user.email || null;
  }
  return null;
}

/**
 * 取得使用者的完整顯示字串，包含主要和次要資訊
 */
export function getUserFullDisplay(user: User | null | undefined, fallback = 'Unknown'): string {
  const primary = getUserDisplayName(user, fallback);
  const secondary = getUserSecondaryInfo(user);
  return secondary ? `${primary} (${secondary})` : primary;
}
